import { useCallback, useEffect, useMemo, useState, useContext } from "react";

import { ReviewedCart } from "@cart-client/interfaces/Cart";
import { BillDetailsCardCommes, PresentationInfo } from "@swiggy-private/cart-types";

import { getNestedValue, isEmpty } from "@swiggy-private/js-utils";
import { AnalyticsContext } from "@swiggy-private/checkout-core";
import { clickMakeItFreeCta } from "@cart-client/analytics/events";

import {
    areValidCtas,
    isSwiggyBlackPlanVariants,
    isSwiggyOnePlanVariants,
} from "@cart-client/helpers/SwiggyPlanBullsEyeTg";
import { SWIGGY_ONE_COMPONENT, SWIGGY_ONE_STATE, recordSwiggyOneNREvent } from "@swiggy-private/super-ui";

export function useSwiggyPlanBullsEyeTG(cartResponse: ReviewedCart | null) {
    const [showBillDetailsOneCardComms, setShowBillDetailsOneCardComms] = useState(false);
    const { clickEvent } = useContext(AnalyticsContext);

    const swiggyPlanInfo: PresentationInfo = useMemo(
        () => getNestedValue(cartResponse, "data.swiggyOneInfo.presentationInfo"),
        [cartResponse],
    );

    const billDetailsCardResponse = useMemo(
        () =>
            areValidCtas(swiggyPlanInfo?.bill_details_card_comms?.ctas)
                ? (swiggyPlanInfo?.bill_details_card_comms as BillDetailsCardCommes)
                : null,
        [swiggyPlanInfo?.bill_details_card_comms],
    );
    const planDetails = useMemo(() => swiggyPlanInfo?.plan_details, [swiggyPlanInfo?.plan_details]);

    const ShouldBullsEyeTGCardMount = useMemo(
        () => isSwiggyOnePlanVariants(planDetails) || isSwiggyBlackPlanVariants(planDetails),
        [planDetails],
    );

    useEffect(() => {
        if (!ShouldBullsEyeTGCardMount) {
            recordSwiggyOneNREvent(SWIGGY_ONE_COMPONENT.BULLS_EYE_TG, SWIGGY_ONE_STATE.PLAN_TYPE_INVALID, {
                planType: planDetails?.type || "",
            });
        }
        if (isEmpty(billDetailsCardResponse)) {
            recordSwiggyOneNREvent(SWIGGY_ONE_COMPONENT.BULLS_EYE_TG, SWIGGY_ONE_STATE.NO_BILL_DETAILS_CARD);
        }
    }, [ShouldBullsEyeTGCardMount, billDetailsCardResponse, planDetails]);

    const setBillDetailsOneCardComms = useCallback(() => {
        if (!isEmpty(billDetailsCardResponse)) {
            setShowBillDetailsOneCardComms(true);

            clickMakeItFreeCta(
                clickEvent,
                JSON.stringify({ planId: planDetails?.plan_id, superStatus: swiggyPlanInfo?.is_super }),
            );
        }
    }, [billDetailsCardResponse, clickEvent, planDetails, swiggyPlanInfo]);

    return {
        billDetailsCardResponse,
        showBillDetailsOneCardComms,
        setShowBillDetailsOneCardComms,
        planDetails,
        ShouldBullsEyeTGCardMount,
        setBillDetailsOneCardComms,
    };
}
